import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUsers } from '../../api/user';
import { User } from './types';

export const usersGetThunk = createAsyncThunk<User[]>(
  'users/get',
  async () => getUsers(),
);
